module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-top-stone-path-remnants.f95a2290.png";